<template>
  <div class="account">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'startValidityTime' || item.prop === 'endValidityTime'">{{
              scope.row[item.prop] | dateSubstr
            }}</span>
            <span v-else-if="item.prop === 'sex'">{{
              { '0': '女', '1': '男' }[scope.row[item.prop]]
            }}</span>
            <span v-else-if="item.prop === 'inoutFlag'">{{
              { I: '内部', O: '外部' }[scope.row[item.prop]]
            }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <addAccount v-on:getData="getData" ref="addAccount"></addAccount>
    <addParter v-on:getData="getData" ref="addParter"></addParter>
    <editAccount v-on:getData="getData" ref="editAccount"></editAccount>
    <editPassword v-on:getData="getData" ref="editPassword"></editPassword>
    <detailAccount v-on:getData="getData" ref="detailAccount"></detailAccount>
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/systemManage/account.js';
  import addAccount from './addModal/addAccount';
  import addParter from './addModal/addParter';
  import editAccount from './editModal/editAccount';
  import editPassword from './editModal/editPassword';
  import detailAccount from './detailModal/assignRole';

  export default {
    name: 'account',
    mixins: [tableMixins],
    components: {
      addAccount,
      editAccount,
      editPassword,
      detailAccount,
      addParter,
    },
    data() {
      return {
        query: {
          userAcct: null,
          userName: null,
        },
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'userAcct',
            name: this.$t('account.search.userAcct'),
            type: 'input',
            placeholder: this.$t('account.search.userAccountPlaceholder'),
          },
          {
            prop: 'userName',
            name: this.$t('account.search.userName'),
            type: 'input',
            placeholder: this.$t('account.search.personNamePlaceholder'),
          },
        ];
      },
      columns() {
        return [
          {
            prop: 'userAccount',
            label: this.$t('account.table.userAccount'),
            sortable: true,
          },
          {
            prop: 'userName',
            label: this.$t('account.table.personName'),
          },
          {
            prop: 'sex',
            label: this.$t('account.table.personSex'),
            width: 120,
          },
          { prop: 'phone', label: this.$t('account.table.phone'), width: 120 },
          { prop: 'email', label: this.$t('account.table.email'), width: 180 },
          {
            prop: 'startValidityTime',
            label: this.$t('account.table.startValidityTime'),
          },
          {
            prop: 'endValidityTime',
            label: this.$t('account.table.endValidityTime'),
          },
          {
            prop: 'inoutFlag',
            label: this.$t('account.table.inoutFlag'),
          },
          { prop: 'remark', label: this.$t('account.table.remark') },
        ];
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
      });
    },
    methods: {
      getButtonList() {
        this.menuButtonList = [
          {
            id: 0,
            label: '新增',
            type: '0',
            attributes: {
              buttonStyle: 'icon-add',
              buttonName: '新增',
              buttonUrl: 'add',
            },
          },
          {
            id: 1,
            label: '修改',
            type: '0',
            attributes: {
              buttonStyle: 'icon-white-edit',
              buttonName: '修改',
              buttonUrl: 'edit',
            },
          },
          {
            id: 2,
            label: '删除',
            type: '0',
            attributes: {
              buttonStyle: 'icon-white-delete',
              buttonName: '删除',
              buttonUrl: 'del',
            },
          },
          {
            id: 3,
            label: '指派角色',
            type: '0',
            attributes: {
              buttonStyle: '',
              buttonName: '指派角色',
              buttonUrl: 'assignRole',
            },
          },
          {
            id: 4,
            label: '新增客户/供应商',
            type: '0',
            attributes: {
              buttonStyle: '',
              buttonName: '新增客户/供应商',
              buttonUrl: 'addOther',
            },
          },
          {
            id: 5,
            label: '重置密码',
            type: '0',
            attributes: {
              buttonStyle: '',
              buttonName: '重置密码',
              buttonUrl: 'resetPasswords',
            },
          },
        ];
        console.log(this.userInfo);
        console.log(this.menuButtonList.filter((item) => item.id == '4'));
        if (this.userInfo.userInfo.isAuth == '2')
          this.menuButtonList = this.menuButtonList.filter((item) => item.id == '4');
      },
      //获取数据
      getData() {
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'addOther') {
          this.$refs.addParter.openDialog(true);
        } else if (type == 'add') {
          this.$refs.addAccount.openDialog(true);
        }
        if (type == 'edit') {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('menu.editTreeTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.editAccount.openDialog(true, this.multipleSelection[0].id);
        }
        if (type == 'del') {
          if (this.multipleSelection.length == 0) {
            this.$message({
              showClose: true,
              message: this.$t('account.deleteTips'),
              type: 'error',
            });
            return;
          }
          this.$confirmAction()
            .then(() => {
              let ids = [];
              this.multipleSelection.forEach((item) => {
                ids.push(item.id);
              });
              this.loading.startLoading();
              this.$axios.post(API.DELETE_ACCOUNT_API, { ids: ids.join(',') }).then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
        if (type == 'assignRole') {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('account.assignRoleTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.detailAccount.openDialog(true, this.multipleSelection[0].userId);
        }
        if (type == 'resetPasswords') {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('menu.editTreeTips'),
              type: 'error',
            });
            return;
          }
          this.$refs.editPassword.openDialog(true, this.multipleSelection[0].id);
        }
      },
    },
  };
</script>
